// extracted by mini-css-extract-plugin
module.exports = {"root":"BalanceChip_root__ORbo9","label":"BalanceChip_label__YQShG","note":"BalanceChip_note__V03KO"};